// alphabet, numeric, space, coma, fullstop
const descriptionRegex = (fieldName) => ({
    msg: `${fieldName} can only contain letters, digits, coma, fullstop and spaces`,
    regex: /^[A-Za-z0-9,. ]*$/
})

// alphabet, numeric, space
const nameRegex = (fieldName) => ({
    msg: `${fieldName} can only contain letters, digits and spaces`,
    regex: /^[A-Za-z0-9 ]*$/
})

// alphabet, numeric, space and fullstop
const nameRegexFullStop = (fieldName) => ({
    msg: `${fieldName} can only contain letters, digits, spaces and full stop`,
    regex: /^[A-Za-z0-9. ]*$/
})


//only letter and number
const letterNum = (fieldName) => ({
    msg: `${fieldName} can only contain letters and digits`,
    regex: /^[A-Za-z0-9]+$/
})

//only alphabetic
const onlyAlphabetic = (fieldName) => ({
    msg: `${fieldName} can only contain letters`,
    regex: /^[A-Za-z]*$/
})

//only alphabetic and space
const alphaSpaces = (fieldName) => ({
    msg: `${fieldName} can only contain letters and spaces`,
    regex: /^[A-Za-z\s]+$/
})


const decimalNum = (precision, scale, fieldName) => ({
    msg: `${fieldName}  must be a number with up to ${precision} digits precision and up to ${scale} digits scale`,
    regex: /^\d{1,10}(\.\d{1,3})?$/
})

const required = (fieldName) => ({
    msg: `${fieldName} is required`,
})

const email = (fieldName) => ({
    msg: `enter valid ${fieldName}`,
})

const emailRegex = (fieldName) => ({
    msg: `enter valid ${fieldName}`,
    regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
})

const maxSize = (fieldName, length) => ({
    msg: `${fieldName} cannot exceed  ${length} item`,
})

const maxLength = (fieldName, length) => ({
    msg: `${fieldName} must be at most ${length} characters long`,
})

// numeric, underscore, asterik
const occCodeRegex = (fieldName) => ({
    msg: `${fieldName} can only contain digits, underscore, and asterisk`,
    regex: /^[0-9_*]*$/
})

// alphabet, numeric
const divCodeRegex = (fieldName) => ({
    msg: `${fieldName} can only contain alphanumeric characters. & is allowed`,
    regex: /^[A-Za-z0-9&]*$/
})

//only Number
const onlyNumRegex = (fieldName) => ({
    msg: `${fieldName} can only contain 10 numeric numbers`,
    regex: /^\d{10}$/
})

const strongPasswordRegex = (fieldName) => ({
    msg: `${fieldName} must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one special character`,
    regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#\-=~^()_+[\]{}|;':",./<>])[A-Za-z\d@$!%*?&#\-=~^()_+[\]{}|;':",./<>]{8,}$/
});

const otpRegex = (fieldName) => ({
    msg: `${fieldName} can only contain 6 numeric numbers`,
    regex: /^\d{6}$/
})

// alphabet, numeric, spaces, hyphen
const typeRegex = (fieldName) => ({
    msg: `${fieldName} can only contain letters, digits and spaces and hyphen`,
    regex: /^[A-Za-z0-9- ]*$/
})

const minLength = (fieldName, length) => ({
    msg: `${fieldName} must be atleast ${length} characters long`,
})

const minSize = (fieldName, length) => ({
    msg: `${fieldName} must have atleast ${length} item`,
})

const policyRegexHyphenSlashScore = (fieldName) => ({
    msg: `${fieldName} can only contain capital small letters, digits, /, hyphen and underscore`,
    regex: /^[A-Za-z0-9 _\-/]*$/
})

const policyRegexHyphenSlash = (fieldName) => ({
    msg: `${fieldName} can only contain small letters, digits, / and hyphen`,
    regex: /^[0-9a-zA-Z/-]+$/
})

const noEscChar = (fieldName) => ({
    msg: `${fieldName} cannot contain <, >, /`,
    regex: /^(?!.*<(script|style|html|body|head|iframe|object|embed|form|input|select|textarea|button|a|link|meta|title|p|div|h1|h2|h3|h4|h5|h6)[^>]*>.*?<\/\1>)(?!.*<[^>]+(?:on\w+|javascript:)[^>]*>).*/
})

export {
    descriptionRegex, divCodeRegex, occCodeRegex, nameRegex, decimalNum, maxLength, required, letterNum, onlyNumRegex, onlyAlphabetic, alphaSpaces, email, emailRegex, typeRegex, minLength, minSize, nameRegexFullStop, otpRegex, strongPasswordRegex,
    policyRegexHyphenSlashScore, policyRegexHyphenSlash, maxSize, noEscChar
};


